var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62644 13.7721C9.78332 13.9239 9.98341 14 10.1924 14C10.4015 14 10.6016 13.9239 10.7585 13.7719C11.0805 13.4602 11.0805 12.9481 10.7585 12.6363L5.96999 8L10.7585 3.36367C11.0805 3.05191 11.0805 2.53981 10.7585 2.22805C10.4445 1.92407 9.94063 1.92398 9.62656 2.22779L4.24163 7.43193C3.91964 7.74369 3.91937 8.25605 4.24136 8.56781L9.62644 13.7721Z",
    transform: "rotate(-180 8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.546e789b92afd618e21070e0cc3065bd.svg";
export { ForwardRef as ReactComponent };